// extracted by mini-css-extract-plugin
export default {"root":"_PRr4","button":"QU7q3","title":"BOFrY","label":"XGffW","dates":"_l7UG","range":"_W4Da","picker":"zLS8b","right":"bibXz","predefined":"X7XFI"};